import { CSSProperties } from 'react';
import { stackVariants } from './logic';

type Gap = 0 | 2 | 4 | 6 | 8 | 12 | 16 | 20 | 24 | 32 | 40 | 48 | 56 | 72 | 88 | 104 | 120;
type Direction = 'row' | 'column';

type Props = {
  /** 間隔の指定（spacingトークンに対応した数値） */
  gap?: Gap;
  /** 積み重ねる要素 */
  children: React.ReactNode;
  /** 間隔を空ける方向 */
  direction?: Direction;
  /** flexアイテムの水平方向の配置方法 */
  justifyContent?: CSSProperties['justifyContent'];
  /** flexアイテムの垂直方向の配置方法 */
  alignItems?: CSSProperties['alignItems'];
  /** 高さの指定 */
  height?: CSSProperties['height'];
  /** 幅の指定 */
  width?: CSSProperties['width'];
  /** 追加のクラス名 */
  className?: string;
};

export const Stack: React.FC<Props> = ({
  gap = 0,
  children,
  direction = 'column',
  justifyContent = 'normal',
  alignItems = 'normal',
  height = 'auto',
  width = 'auto',
  className,
}) => {
  const stackClassName = stackVariants({
    direction,
    spacing: gap,
  });

  const combinedClassName = className ? `${stackClassName} ${className}` : stackClassName;

  return (
    <div
      className={combinedClassName}
      style={{
        alignItems,
        justifyContent,
        height,
        width,
      }}
    >
      {children}
    </div>
  );
};
